import { AssistanceState } from 'src/generated/signalR/assistance-state';
import { UserAssistanceStatesRealTimeData } from 'src/generated/signalR/user-assistance-states-real-time-data';

export class UpdateUserAssistanceStates {
   public static readonly type = '[SamwinUserAssistanceState] update assistance state of single user';

   constructor(public data: UserAssistanceStatesRealTimeData) {}
}

export class UpdateDesiredAssistanceState {
   public static readonly type = '[SamwinUserAssistanceState] update desired assistance state';

   constructor(public desiredState: AssistanceState) {}
}
